<template>
  <article class="hotel">
    <div class="hotel__name">
      <a :href="hotel.url" target="_blank" rel="noopener noreferrer">{{ hotel.name }}</a>
      <HotelCategory :value="hotel.categoryGroup" />
    </div>
    <div class="hotel__location">
      <SvgIcon icon="location" />
      <span>{{ hotel.location }}</span>
    </div>
    <ul v-if="localHotelAttributes.length > 0" class="hotel__attributes">
      <li
        v-for="attr in localHotelAttributes"
        :key="attr.name"
        class="hotel__attr"
        v-tippy="$tippyOptions(attr.name)"
      >
        <SvgIcon v-if="attr.icon" :icon="attr.icon" class="hotel__attr-icon" />
        <span class="hotel__attr-name">{{ attr.name }}</span>
      </li>
    </ul>
  </article>
</template>

<script setup>
import HotelCategory from "./HotelCategory.vue";
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import { useHotelDirectoryListItem } from "./HotelDirectoryListItemBase";

const props = defineProps({
  hotel: { type: Object, required: true },
  hotelAttributes: { type: Array, required: true },
});

const { localHotelAttributes } = useHotelDirectoryListItem(props);
</script>

<style scoped lang="scss">
.hotel {
  padding: 15px 16px;
  background-color: var(--white);
}

.hotel__name {
  line-height: 24px;
  font-weight: 600;

  > a {
    font-size: 16px;
    line-height: inherit;
  }

  .hd-hotel-category {
    height: 24px;
    vertical-align: top;
    margin-inline-start: 8px;
  }
}

.hotel__location {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 5px;

  > * {
    min-width: 0;
    flex: 1 1 0;
  }

  > svg {
    flex: 0 0 auto;
  }
}

.hotel__attributes {
  display: flex;
  flex-flow: row wrap;
  gap: 5px 8px;
  list-style-type: none;
  padding: 0;
  margin: 10px 0 0;
}

.hotel__attr {
  font-size: 11px;
  line-height: 16px;
  padding: 4px 8px;
  background-color: var(--main-40);
  border-radius: var(--border-radius-sm);
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: default;
  max-width: 120px;

  > .hotel__attr-icon {
    flex: 0 0 auto;
  }

  > .hotel__attr-name {
    flex: 1 1 0;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
